import { __read } from "tslib";
import React, { useCallback, useMemo, useState } from 'react';
import { useCarouselControlStyles } from './CarouselControl.styles';
import { CarouselHeader } from './CarouselHeader';
import { CarouselHeaderAccordion } from './CarouselHeaderAccordion';
import { CarouselList } from './CarouselList';
import { useNavigation } from './hooks';
export var CarouselControl = function (props) {
    var _a;
    var styles = useCarouselControlStyles();
    var _b = props.arrowKeyListNavEnabled, arrowKeyListNavEnabled = _b === void 0 ? false : _b, builtInButtons = props.builtInButtons, cards = props.cards, carouselBottomMargin = props.carouselBottomMargin, carouselResources = props.carouselResources, callbacks = props.callbacks, cardGutterWidth = props.cardGutterWidth, carouselTitle = props.carouselTitle, compositeCarouselTitle = props.compositeCarouselTitle, direction = props.direction, getItemDimensionsForBreakpoint = props.getItemDimensionsForBreakpoint, headerOptions = props.headerOptions, hideNavWhenDisabled = props.hideNavWhenDisabled, isVisualRefresh = props.isVisualRefresh, renderItem = props.renderItem, resizeOptions = props.resizeOptions, isDesktopNav = props.isDesktopNav, isAccordion = props.isAccordion;
    // Header state
    var _c = __read(useState(!!headerOptions.isCollapsed), 2), isHeaderCollapsed = _c[0], setIsHeaderCollapsed = _c[1];
    var isCollapsible = (_a = headerOptions.isCollapsible) !== null && _a !== void 0 ? _a : false;
    var isRtl = useMemo(function () {
        return direction === 'rtl';
    }, [direction]);
    var handleHeaderClick = useCallback(function () {
        setIsHeaderCollapsed(!isHeaderCollapsed);
        if (headerOptions === null || headerOptions === void 0 ? void 0 : headerOptions.onCarouselToggled) {
            headerOptions.onCarouselToggled(!isHeaderCollapsed);
        }
    }, [headerOptions, isHeaderCollapsed]);
    var AccordionHeaderOptions = useMemo(function () {
        return {
            isCollapsed: isHeaderCollapsed,
            title: carouselTitle,
            isCollapsible: isCollapsible,
        };
    }, [carouselTitle, isCollapsible, isHeaderCollapsed]);
    var collapsibleHeaderOptions = useMemo(function () {
        if (!(headerOptions === null || headerOptions === void 0 ? void 0 : headerOptions.onCarouselToggled)) {
            return undefined;
        }
        return {
            headerResources: carouselResources
                ? {
                    collapseHeaderAriaLabel: carouselResources.collapseHeaderAriaLabel,
                    expandHeaderAriaLabel: carouselResources.expandHeaderAriaLabel,
                }
                : undefined,
            isCollapsed: isHeaderCollapsed,
            isRtl: isRtl,
            onCarouselToggled: handleHeaderClick,
        };
    }, [
        headerOptions === null || headerOptions === void 0 ? void 0 : headerOptions.onCarouselToggled,
        carouselResources,
        isHeaderCollapsed,
        isRtl,
        handleHeaderClick,
    ]);
    // $TODO: Split these out into two objects. One that does the resize and one that handles nav
    // Both are related and calculate how many cards can fit in one page
    var navResize = useNavigation({
        arrowKeyListNavEnabled: arrowKeyListNavEnabled,
        builtInButtons: builtInButtons,
        cards: cards,
        cardGutterWidth: cardGutterWidth,
        callbacks: callbacks,
        carouselResources: carouselResources,
        hideNavWhenDisabled: hideNavWhenDisabled,
        isHeaderCollapsed: isHeaderCollapsed,
        isRtl: isRtl,
        isVisualRefresh: isVisualRefresh,
        getItemDimensionsForBreakpoint: getItemDimensionsForBreakpoint,
        resizeOptions: resizeOptions,
        isDesktopNav: isDesktopNav,
    });
    return (React.createElement("div", { className: styles.carousel }, isAccordion ? (React.createElement(CarouselHeaderAccordion, { headerType: headerOptions.type, navigationOptions: navResize.navigationOptions, title: carouselTitle, options: AccordionHeaderOptions }, cards && cards.length > 0 ? (React.createElement(CarouselList, { builtInButtonOptions: navResize.builtInButtonOptions, cardGutterWidth: cardGutterWidth, carouselBottomMargin: carouselBottomMargin, cards: cards, containerKey: carouselTitle, getItemDimensionsForBreakpoint: getItemDimensionsForBreakpoint, isMobileOrTabletDevice: navResize.isMobileOrTabletDevice, isRtl: isRtl, keyboardNavigationOptions: navResize.keyboardNavigationOptions, navigationState: navResize.navigationState, onResize: navResize.onResize, renderItem: renderItem, resizeOptions: resizeOptions, resizeState: navResize.resizeState })) : null)) : (React.createElement(React.Fragment, null,
        React.createElement(CarouselHeader, { collapsibleHeaderOptions: collapsibleHeaderOptions, headerType: headerOptions.type, navigationOptions: navResize.navigationOptions, title: carouselTitle, compositeTitle: compositeCarouselTitle }),
        cards && cards.length > 0 && !isHeaderCollapsed ? (React.createElement(CarouselList, { builtInButtonOptions: navResize.builtInButtonOptions, cardGutterWidth: cardGutterWidth, carouselBottomMargin: carouselBottomMargin, cards: cards, containerKey: carouselTitle, getItemDimensionsForBreakpoint: getItemDimensionsForBreakpoint, isMobileOrTabletDevice: navResize.isMobileOrTabletDevice, isRtl: isRtl, keyboardNavigationOptions: navResize.keyboardNavigationOptions, navigationState: navResize.navigationState, onResize: navResize.onResize, renderItem: renderItem, resizeOptions: resizeOptions, resizeState: navResize.resizeState })) : null))));
};
//# sourceMappingURL=CarouselControl.js.map